import { addAndTrack, simpleAnTmaker } from "../../../calculators/helpers";
import { Green } from "../../../styledCpns/DataDisplay";
import { CaStamina, mediumPAs } from "../config";
import { checkAscs, checkCons, makeTlBnes, xtraTlLv } from "../helpers";

const Yaoyao = {
  code: 66,
  name: "Yaoyao",
  icon: "8/83/Yaoyao_Icon",
  sideIcon: "d/d2/Character_Yaoyao_Side_Icon",
  rarity: 4,
  nation: "Liyue",
  vision: "Dendro",
  weapon: "Polearm",
  stats: [
    { "Base HP": 1030, "Base ATK": 18, "Base DEF": 63 },
    { "Base HP": 2647, "Base ATK": 46, "Base DEF": 162 },
    { "Base HP": 3417, "Base ATK": 59, "Base DEF": 209 },
    { "Base HP": 5118, "Base ATK": 88, "Base DEF": 313 },
    { "Base HP": 5665, "Base ATK": 98, "Base DEF": 346, "HP%": 6 },
    { "Base HP": 6516, "Base ATK": 113, "Base DEF": 398, "HP%": 6 },
    { "Base HP": 7245, "Base ATK": 125, "Base DEF": 443, "HP%": 12 },
    { "Base HP": 8096, "Base ATK": 140, "Base DEF": 495, "HP%": 12 },
    { "Base HP": 8643, "Base ATK": 149, "Base DEF": 528, "HP%": 12 },
    { "Base HP": 9493, "Base ATK": 164, "Base DEF": 580, "HP%": 12 },
    { "Base HP": 10040, "Base ATK": 174, "Base DEF": 613, "HP%": 18 },
    { "Base HP": 10891, "Base ATK": 188, "Base DEF": 665, "HP%": 18 },
    { "Base HP": 11438, "Base ATK": 198, "Base DEF": 699, "HP%": 24 },
    { "Base HP": 12289, "Base ATK": 212, "Base DEF": 751, "HP%": 24 }
  ],
  actvTalents: [
    {
      type: "Normal Attack",
      name: "Toss ‘N’ Turn Spear",
      desc: [],
      stats: [
        {
          name: "1-Hit",
          dmgTypes: ["NA", "Physical"],
          baseMult: 51,
          multType: 1
        },
        {
          name: "2-Hit",
          dmgTypes: ["NA", "Physical"],
          baseMult: 47.44,
          multType: 1
        },
        {
          name: "3-Hit",
          dmgTypes: ["NA", "Physical"],
          baseMult: [31.38, 32.95],
          multType: 1
        },
        {
          name: "4-Hit",
          dmgTypes: ["NA", "Physical"],
          baseMult: 77.93,
          multType: 1
        },
        {
          name: "Charged Attack",
          dmgTypes: ["CA", "Physical"],
          baseMult: 112.66,
          multType: 1
        },
        CaStamina[25],
        ...mediumPAs
      ]
    },
    {
      type: "Elemental Skill",
      name: "Raphanus Sky Cluster",
      image: "2/25/Talent_Raphanus_Sky_Cluster",
      desc: [],
      getXtraLv: xtraTlLv.cons3,
      stats: [
        {
          name: "White Jade Radish DMG",
          dmgTypes: ["ES", "Elemental"],
          baseMult: 29.92,
          multType: 2
        },
        {
          name: "White Jade Radish Healing",
          isHealing: true,
          baseSType: "HP",
          baseMult: 1.71,
          multType: 2,
          baseFlat: 165,
          flatType: 3
        },
        {
          name: "Radish Extra Healing per sec (A4)",
          isHealing: true,
          baseSType: "HP",
          baseMult: 0,
          multType: 2,
          conditional: true,
          getTlBnes: ({ char }) =>
            makeTlBnes(checkAscs[4](char), "mult", [1, 4], 0.8)
        },
        {
          name: "Mega Radish DMG (C6)",
          dmgTypes: ["ES", "Elemental"],
          baseMult: 0,
          multType: 2,
          conditional: true,
          getTlBnes: ({ char }) =>
            makeTlBnes(checkCons[6](char), "mult", [0, 6], 75)
        },
        {
          name: "Mega Radish Healing (C6)",
          isHealing: true,
          baseSType: "HP",
          baseMult: 0,
          multType: 2,
          conditional: true,
          getTlBnes: ({ char }) =>
            makeTlBnes(checkCons[6](char), "mult", [0, 6], 7.5)
        }
      ],
      otherStats: () => []
    },
    {
      type: "Elemental Burst",
      name: "Moonjade Descent",
      image: "c/ca/Talent_Moonjade_Descent",
      desc: [],
      getXtraLv: xtraTlLv.cons5,
      stats: [
        {
          name: "Skill DMG",
          dmgTypes: ["EB", "Elemental"],
          baseMult: 114.56,
          multType: 2
        },
        {
          name: "Adeptal Legacy Radish DMG",
          dmgTypes: ["EB", "Elemental"],
          baseMult: 72.16,
          multType: 2
        },
        {
          name: "Adeptal Legacy Radish Healing",
          isHealing: true,
          baseSType: "HP",
          baseMult: 2.02,
          multType: 2,
          baseFlat: 194,
          flatType: 3
        }
      ],
      otherStats: () => [],
      energyCost: 80
    }
  ],
  pasvTalents: [
    {
      type: "Ascension 1",
      name: "Starscatter",
      image: "d/d5/Talent_Starscatter",
      desc: (
        <>
          While affected by the Adeptal Legacy state caused by Moonjade Descent
          [EB], Yaoyao will constantly throw White Jade Radishes at nearby
          opponents when she is sprinting, jumping, or running. She can throw 1
          White Jade Radish this way once every 0.6s.
        </>
      )
    },
    {
      type: "Ascension 4",
      name: "In Others’ Shoes",
      image: "a/ab/Talent_In_Others%27_Shoes",
      desc: (
        <>
          When White Jade Radishes explode, active characters within their AoE
          will regain HP every 1s based on 0.8% of Yaoyao’s Max HP. This effect
          lasts 5s.
        </>
      )
    },
    {
      type: "Passive",
      name: "Tailing on Tiptoes",
      image: "8/89/Talent_Tailing_on_Tiptoes",
      desc: ""
    }
  ],
  constellation: [
    {
      name: "Adeptus’ Tutelage",
      image: "2/2a/Constellation_Adeptus%27_Tutelage",
      get desc() {
        return (
          <>
            {this.buff} and have <Green b>15</Green> <Green>Stamina</Green>{" "}
            restored to them. This form of Stamina Restoration can only be
            triggered every 5s.
          </>
        );
      },
      buff: (
        <>
          When White Jade Radishes explode, active characters within their AoE
          will gain <Green b>15%</Green> <Green b>Dendro DMG Bonus</Green> for
          8s
        </>
      )
    },
    {
      name: "Innocent",
      image: "3/3d/Constellation_Innocent",
      desc: (
        <>
          While affected by the Adeptal Legacy state caused by Moonjade Descent
          [EB], if White Jade Radish explosions damage opponents, 3 Energy will
          be restored to Yaoyao. This form of Energy regeneration can occur once
          every 0.8s.
        </>
      )
    },
    {
      name: "Loyal and Kind",
      image: "6/66/Constellation_Loyal_and_Kind",
      desc: "Raphanus Sky Cluster"
    },
    {
      name: "Winsome",
      image: "3/39/Constellation_Winsome",
      desc: (
        <>
          After using Raphanus Sky Cluster [ES] or Moonjade Descent [EB],
          Yaoyao’s <Green>Elemental Mastery</Green> will be increased based on{" "}
          <Green b>0.3%</Green> of her <Green>Max HP</Green> for 8s. The maximum
          Elemental Mastery she can gain this way is 120.
        </>
      )
    },
    {
      name: "Compassionate",
      image: "3/3d/Constellation_Compassionate",
      desc: "Moonjade Descent"
    },
    {
      name: "Beneficent",
      image: "0/02/Constellation_Beneficent",
      desc: (
        <>
          When Yuegui: Throwing Mode [ES] throws out a White Jade Radish, there
          is a 50% chance that it will throw out a Mega Radish that will have a
          larger AoE than the standard White Jade Radish and have the following
          effects upon exploding:
          <br />• Deals AoE Dendro DMG based on <Green b>75%</Green> of Yaoyao’s{" "}
          <Green>ATK</Green>.
          <br />• Restores HP for the active character based on{" "}
          <Green b>7.5%</Green> of Yaoyao’s <Green>Max HP</Green>.
          <br />
          Every Yuegei: Throwing Mode can throw out a maximum of 2 Mega
          Radishes.
        </>
      )
    }
  ],
  buffs: [
    {
      index: 0,
      src: "Constellation 1",
      desc: () => Yaoyao.constellation[0].buff,
      isGranted: checkCons[1],
      affect: "party",
      addBnes: simpleAnTmaker("ATTRs", "Dendro DMG Bonus", 15)
    },
    {
      index: 4,
      src: "Constellation 4",
      desc: () => Yaoyao.constellation[3].desc,
      isGranted: checkCons[4],
      affect: "self",
      addFinalBnes: ({ tkDesc, ATTRs, tracker }) => {
        const bnValue = Math.min(ATTRs.HP * 0.03, 120);
        addAndTrack(tkDesc, ATTRs, "Elemental Mastery", bnValue, tracker);
      }
    }
  ]
};

export default Yaoyao;
